var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-pager-small.69c0c610.png","uri@2x": __webpack_public_path__ + "icon-pager-small.2fb65ab3.png","uri@3x": __webpack_public_path__ + "icon-pager-small.e57f1e4c.png",
    width: 24,
    height: 18
});